import React from 'react';
import styles from '../c1c-header.module.css';
import { isGovCloudRegion } from '../utils';

import { Box as Wrapper, Stack, Text } from '@tonic-ui/react';

const Banner = ({ t }) => {
  return (
    <Wrapper
      className={`${isGovCloudRegion ? styles.banner_container_govcloud : styles.banner_container}`}
      data-id="header-banner"
    >
      <Stack direction="column" spacing="2x">
        <Text
          fontSize="7xl"
          fontWeight="extralight"
          lineHeight="normal"
          letterSpacing="0"
          fontFamily="interstate"
        >
          {t('cloudOneHeader.title')}
          <Text as="sup" display="inline">
            &trade;
          </Text>
        </Text>
        <Text
          fontSize="md"
          fontWeight="light"
          lineHeight="sm"
          letterSpacing="0"
          fontFamily="interstate"
        >
          {t('cloudOneHeader.description')}
        </Text>
      </Stack>
    </Wrapper>
  );
};
export default Banner;
